import { ReactNode } from 'react'

interface NotificationBarProps {
   message: ReactNode
   action?: ReactNode
}

export const NotificationBar = ({ message, action }: NotificationBarProps) => {
   return (
      <div className="flex items-center py-1 pl-8 pr-4 mb-4 border bg-primary/10 border-white/10 rounded-xl">
         <p className="w-full py-3 text-sm font-normal">{message}</p>
         {action}
      </div>
   )
}
